(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(function () {
            $.datepicker.setDefaults($.datepicker.regional['ru']);

            $.datepicker._generateHTML = function () {
                var realGenerateHtml = $.datepicker._generateHTML;
                return function (instance) {
                    var html = realGenerateHtml.apply(this, arguments),
                        $temp = void 0;

                    if (instance.input.is("#calendar-prices")) {
                        $temp = $("<table></table>").append(html);
                        $temp.find(".ui-datepicker-calendar td a").each(function (index, element) {
                            var year = $(this).parent().data("year");
                            var month = $(this).parent().data("month") + 1;
                            var day = +$(this).text();
                            var date = year + "-" + month + "-" + day;
                            // 2019-6-1, safari сам не умеет парсить такую дату, поэтому обязательно надо добавлять формат
                            var dateMoment = moment(date, 'YYYY-M-D');

                            var hasPrice = calendarPrices[year + "-" + month + "-" + day] !== undefined;
                            var price = hasPrice ? calendarPrices[year + "-" + month + "-" + day]['price'] : '----';
                            var dayLabel = dateMoment.format('DD MMM');
                            var cssClass = !hasPrice ? 'no-price' : 'calendar-select-date';

                            $(element).html("<small class='price'>" + price + "</small><br><span class=\"date\" data-day=\"" + day + "\">" + dayLabel + "</span>").attr('data-date', date).addClass(cssClass);
                        });
                        html = $temp[0].innerHTML;
                    }

                    return html;
                };
            }();

            $.datepicker._selectDay = function (id, month, year, td) {
                var inst,
                    target = $(id);

                if ($(td).hasClass(this._unselectableClass) || this._isDisabledDatepicker(target[0]) || $(td).find('a').hasClass('no-price')) {
                    return;
                }
                inst = this._getInst(target[0]);
                inst.selectedDay = inst.currentDay = $(".date", td).data('day');
                inst.selectedMonth = inst.currentMonth = month;
                inst.selectedYear = inst.currentYear = year;
                this._selectDate(id, this._formatDate(inst, inst.currentDay, inst.currentMonth, inst.currentYear));
            };

            $('#calendar-prices').datepicker({
                showOtherMonths: true,
                selectOtherMonths: true,
                nextText: '',
                prevText: '',
                defaultDate: calendarDefaultDate,
                onSelect: function onSelect(text, ui) {

                    ui.inline = false;
                    var year = ui.selectedYear;
                    var month = ui.selectedMonth + 1;
                    var day = ui.selectedDay;
                    var date = year + "-" + month + "-" + day;

                    $('.calendar-select-date').each(function (index, element) {
                        $(element).closest('td').removeClass('active');
                    });
                    var $currentA = $(".calendar-select-date[data-date=\"" + date + "\"]");
                    if ($currentA.length) {
                        $currentA.closest('td').addClass('active');
                    }

                    $('body').trigger('calendar:onSelectDate', {
                        year: year,
                        month: month,
                        day: day
                    });
                }
            });
        });
    }, {}] }, {}, [1]);